export const FAQ = JSON.stringify({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "What is a lucky draw tool?",
      acceptedAnswer: {
        "@type": "Answer",
        text:
          "A software or platform for randomly selecting winners in contests or events.",
      },
    },
    {
      "@type": "Question",
      name: "How does a lucky draw tool work?",
      acceptedAnswer: {
        "@type": "Answer",
        text:
          "Users input participants, and the tool randomly selects winners based on settings.",
      },
    },
    {
      "@type": "Question",
      name: "What tools can I use to do a lucky draw?",
      acceptedAnswer: {
        "@type": "Answer",
        text:
          "<strong><a href=http://luckydraw.me/>Lucky Draw Simulator</a></strong> is a great tool which many companies and individuals trust and use to ensure a fair and transparent drawing process. It is free and easy to use which requires only a few configurations to get started right away.",
      },
    },
    {
      "@type": "Question",
      name: "How does a lucky draw work?",
      acceptedAnswer: {
        "@type": "Answer",
        text:
          "A lucky draw is a gambling competition in which people randomly obtain numbered tickets and each tickets have a chance of winning a prize. A numbered ticket is selected at random and the selected winner walks away with a prize.",
      },
    },
    {
      "@type": "Question",
      name: "How can I ensure that the tool is fair and random?",
      acceptedAnswer: {
        "@type": "Answer",
        text:
          "Look for certified random number generators and transparency features.",
      },
    },
    {
      "@type": "Question",
      name: "Does the tool support multiple winners?",
      acceptedAnswer: {
        "@type": "Answer",
        text:
          "Yes, <strong><a href=http://luckydraw.me/>Lucky Draw Simulator</a></strong> allow selecting multiple winners per draw.",
      },
    },
    {
      "@type": "Question",
      name: "How do you hold a lucky draw?",
      acceptedAnswer: {
        "@type": "Answer",
        text:
          "Any company or individuals can easily host a lucky draw online simply by setting a certain requirements and prepare rewards for the winners. Tools such as <strong><a href=http://luckydraw.me/>Lucky Draw Simulator</a></strong> is then used to select the winners, ensuring a fair and transparent drawing process.",
      },
    },
    {
      "@type": "Question",
      name: "What is a good lucky draw prize?",
      acceptedAnswer: {
        "@type": "Answer",
        text:
          "Prizes such as Electronic Devices, Gift Baskets, Seasonal Products, Television, Gift Vouchers and Travel Voucher are popular lucky draw prize ideas.",
      },
    },
    {
      "@type": "Question",
      name: "How secure is the Luckydraw.me for storing data?",
      acceptedAnswer: {
        "@type": "Answer",
        text:
          "<strong><a href=http://luckydraw.me/>Lucky Draw Simulator</a></strong> uses a secure server and does not store any of the information used.",
      },
    },
    {
      "@type": "Question",
      name: "What are popular lucky draw tools?",
      acceptedAnswer: {
        "@type": "Answer",
        text:
          "Popular options include <strong><a href=http://luckydraw.me/>LuckyDraw.me</a></strong>, RandomPicker, and Comment Picker.",
      },
    },
  ],
});

export const REVIEW = JSON.stringify({
  "@context": "https://schema.org/",
  "@type": "CreativeWorkSeries",
  name: "Lucky Draw Random Generator Tool",
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "5",
    bestRating: "5",
    ratingCount: "689840",
  },
});
